"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderDetail',
  data: function data() {
    return {
      visible: false,
      loading: false,
      orderDetail: {}
    };
  },
  computed: {
    reservationDateDisplay: function reservationDateDisplay() {
      return this.getReservationDate(this.orderDetail);
    },
    showReservationDate: function showReservationDate() {
      return !!this.reservationDateDisplay;
    }
  },
  methods: {
    getReservationDate: function getReservationDate(detail) {
      if (!detail || _typeof(detail) !== 'object') return '';
      var candidates = [detail.reservationDate, detail.appointmentDate, detail.bookDate, detail.expireDate, detail.appointmentTime];
      var orderItems = Array.isArray(detail.orderItems) ? detail.orderItems : [];
      orderItems.forEach(function (item) {
        candidates.push(item && item.reservationDate, item && item.appointmentDate, item && item.expireDate, item && item.appointmentTime);
      });
      var value = candidates.find(function (v) {
        return v !== null && v !== undefined && String(v).trim() !== '';
      });
      return value ? String(value).trim() : '';
    },
    open: function open(orderNo) {
      this.visible = true;
      console.log(orderNo);
      if (orderNo) {
        this.getOrderDetail(orderNo);
      }
    },
    getOrderDetail: function () {
      var _getOrderDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(orderNo) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _rsManagement.getTgOrderDetail)(orderNo);
            case 2:
              res = _context.v;
              if (res) {
                this.orderDetail = res;
                // 如果商品明细是单个对象，转换为数组
                // if (res.productList && !Array.isArray(res.productList)) {
                //   this.orderDetail.productList = [res.productList]
                // }
                // // 如果没有商品明细数组，尝试从单个商品字段构建
                // if (!this.orderDetail.productList && res.productName) {
                //   this.orderDetail.productList = [{
                //     id: res.productId || res.id,
                //     productName: res.productName,
                //     merchantName: res.merchantName,
                //     storeName: res.storeName,
                //     categoryName: res.categoryName,
                //     quantity: res.quantity || 1,
                //     unitPrice: res.unitPrice || res.totalPrice,
                //     totalPrice: res.totalPrice,
                //     image: res.productImage || res.image,
                //     validityEndTime: res.validityEndTime || res.itemValidity,
                //     status: res.status,
                //     statusName: res.statusName
                //   }]
                // }
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取订单详情失败：', _t);
              this.$message.error('获取订单详情失败：' + (_t.message || '未知错误'));
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getOrderDetail(_x) {
        return _getOrderDetail.apply(this, arguments);
      }
      return getOrderDetail;
    }(),
    handleClose: function handleClose() {
      this.visible = false;
      this.orderDetail = {};
    },
    // formatPrice(value) {
    //   if (value === null || value === undefined || value === '') {
    //     return '0.00'
    //   }
    //   const num = Number(value)
    //   return Number.isNaN(num) ? '0.00' : num.toFixed(2)
    // },
    getOrderStatusType: function getOrderStatusType(orderStatus) {
      if (!orderStatus) return 'info';
      var status = String(orderStatus);

      // 根据中文状态文本匹配
      if (status.includes('取消') || status.includes('cancelled') || status.includes('cancel')) {
        return 'danger';
      } else if (status.includes('待支付') || status.includes('pending') || status.includes('待付款')) {
        return 'warning';
      } else if (status.includes('已支付') || status.includes('paid') || status.includes('支付')) {
        return 'primary';
      } else if (status.includes('已使用') || status.includes('used') || status.includes('已完成') || status.includes('完成')) {
        return 'success';
      } else if (status.includes('退款中') || status.includes('refunding')) {
        return 'warning';
      } else if (status.includes('退款成功') || status.includes('refunded')) {
        return 'success';
      } else if (status.includes('退款失败') || status.includes('refund_failed')) {
        return 'danger';
      } else if (status.includes('已完结') || status.includes('finished')) {
        return 'success';
      }

      // 数字状态码兼容
      var statusMap = {
        '0': 'danger',
        '1': 'warning',
        '2': 'primary',
        '3': 'success',
        '4': 'warning',
        '5': 'success',
        '6': 'danger',
        '10': 'success'
      };
      return statusMap[status] || 'info';
    },
    getOrderStatusText: function getOrderStatusText(orderStatus) {
      if (!orderStatus) return '-';
      var status = String(orderStatus).toLowerCase();

      // 如果已经是中文，直接返回
      if (/[\u4e00-\u9fa5]/.test(orderStatus)) {
        return orderStatus;
      }

      // 根据英文状态匹配中文
      if (status.includes('cancelled') || status.includes('cancel')) {
        return '已取消';
      } else if (status.includes('pending') || status.includes('unpaid')) {
        return '待支付';
      } else if (status.includes('paid') || status.includes('payment')) {
        return '已支付';
      } else if (status.includes('used') || status.includes('completed')) {
        return '已使用';
      } else if (status.includes('refunding')) {
        return '退款中';
      } else if (status.includes('refunded') || status.includes('refund_success')) {
        return '退款成功';
      } else if (status.includes('refund_failed') || status.includes('refund_fail')) {
        return '退款失败';
      } else if (status.includes('finished') || status.includes('done')) {
        return '已完结';
      }

      // 数字状态码映射
      var statusMap = {
        '0': '已取消',
        '1': '待支付',
        '2': '已支付',
        '3': '已使用',
        '4': '退款中',
        '5': '退款成功',
        '6': '退款失败',
        '10': '已完结'
      };
      return statusMap[status] || orderStatus || '未知状态';
    }
  }
};